import { TooltipProps } from '@mui/material';
import { ResponsiveStyleValue } from '@mui/system';

export const PAGE_PADDING: ResponsiveStyleValue<number> = {
  xs: 2,
  md: 4,
};

export const DEFAULT_TOOLTIP_PROPS: Partial<TooltipProps> = {
  placement: 'top',
  arrow: true,
  slotProps: {
    popper: {
      modifiers: [
        {
          name: 'offset',
          options: {
            offset: [0, -5],
          },
        },
      ],
    },
  },
};

/**
 * The soft-panel language: a peach glow rising off the top edge of a panel that
 * is almost, but not quite, white. Shared so the modals that use it stay the
 * same modal family.
 */
export const SOFT_PANEL = {
  background: `radial-gradient(120% 80% at 50% -20%, rgba(255, 214, 206, 0.45) 0%, rgba(255, 214, 206, 0) 55%), linear-gradient(180deg, #FFFFFF 0%, #FCFBF9 100%)`,
  shadow: `0 30px 80px -20px rgba(20, 18, 15, 0.35), 0 0 0 1px rgba(20, 18, 15, 0.04)`,
  hairline: 'rgba(20, 18, 15, 0.08)',
  wash: 'rgba(20, 18, 15, 0.04)',
} as const;

/**
 * A <button> used as a plain surface. Buttons inherit neither type nor color,
 * and their children get wrapped in an anonymous box, so the flex layout has to
 * live inside rather than on the button itself.
 */
export const UNSTYLED_BUTTON_SX = {
  display: 'block',
  width: '100%',
  border: 'none',
  background: 'none',
  padding: 0,
  fontFamily: 'inherit',
  color: 'inherit',
  textAlign: 'left',
  cursor: 'pointer',
} as const;
